export default __webpack_public_path__ + "static/media/Autokritigallery_27.79434a79.JPG";